import { Radio, RadioProps } from "antd";
import { Control, Path } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { triggerUnifiedResize, useIsUnifiedMode } from "@/shared/utils";
import { FormType } from "../../types/form-type";

interface IObjectFormRadio {
  name: Path<FormType>;
  control: Control<FormType>;
  label?: string;
  radioOptions: RadioProps[];
}

export function ObjectFormRadio({
  name,
  control,
  label,
  radioOptions,
}: IObjectFormRadio) {
  const isUnifiedMode = useIsUnifiedMode();

  const handleChange = () => {
    if (isUnifiedMode) {
      triggerUnifiedResize();
    }
  };

  return (
    <FormItem style={{ margin: 0 }} control={control} name={name} label={label}>
      <Radio.Group onChange={handleChange}>
        {radioOptions.map((params) => {
          return (
            <Radio key={params.value} {...params}>
              {params.title}
            </Radio>
          );
        })}
      </Radio.Group>
    </FormItem>
  );
}
